import RouteAuth from './route-auth'
import RouteBase from './route-base'
import RouteCossBorder from './route-crossborder'
import RouteEntityGoods from './route-entitygoods'
import RouteTradenormalorders from './route-tradenormalorders'
import RouteMember from './route-member'
import RouteSellers from './route-sellers'
import RouteStore from './route-store'
import RoutePc from './route-pc'
import RouteMarketing from './route-marketing'
import RouteGuide from './route-guide'
import RouteFinancial from './route-financial'
import RouteCompanydata from './route-companydata'
import RouteSite from './route-site'
import RouteSetting from './route-setting'
import RouteTemplate from './route-template'
import RoutePointsmal from './route-pointsmall'
import RouteDealer from './route-dealer'
import RouteApplications from './route-applications'
import RouteYibao from './route-yibao'

/* shopadmin router */
import RouteShopAdminShopList from './route-shopadmin-shoplist'
import RouteShopAdminEntity from './route-shopadmin-entity'
import RouteShopAdminOrder from './route-shopadmin-order'
import RouteShopAdminMember from './route-shopadmin-member'
import RouteShopAdminStore from './route-shopadmin-store'
import RouteShopAdminMarketing from './route-shopadmin-marketing'
import RouteShopAdminStatistics from './route-shopadmin-statistics'
import RouteShopAdminShopSetting from './route-shopadmin-shopsetting'
import RouteShopAdminPointsMall from './route-shopadmin-pointsmall'
import RouteShopAdminYiBao from './route-shopadmin-yibao'

/* Merchant router */
import RouteMerchantBase from './router-merchant-base'
import RouteMerchantOrder from '../merchant/route-order'
import RouteMerchantSellers from '../merchant/route-sellers'
import RouteMerchantCompanydata from '../merchant/route-companydata'
import RouteMerchantSetting from '../merchant/route-setting'
import RouteMerchantMarkteing from '../merchant/route-marketing'
import RouteMerchantGoods from '../merchant/route-entitygoods'
import RouteMerchantPoint from '../merchant/route-pointsmall'
import RouteMerchantTemplate from '../merchant/route-template'
import RouteMerchantYiBao from '../merchant/route-yibao'


// dealer
import RouteDealerInfomation from './route-dealer-infomation'
import RouteDealerShop from './route-dealer-shop'
import RouteDealerTransaction from './route-dealer-transaction'
import RouteDealerIndex from './route-dealer-index'
import RouteDealerSetting from './route-dealer-setting'

export default {
  RouteAuth,
  RouteBase,
  RouteCossBorder,
  RouteEntityGoods,
  RouteTradenormalorders,
  RouteMember,
  RouteSellers,
  RouteStore,
  RoutePc,
  RouteMarketing,
  RouteGuide,
  RouteFinancial,
  RouteCompanydata,
  RouteSite,
  RouteSetting,
  RouteTemplate,
  RoutePointsmal,
  RouteDealer,
  RouteApplications,
  RouteShopAdminShopList,
  RouteShopAdminEntity,
  RouteShopAdminOrder,
  RouteShopAdminMember,
  RouteShopAdminStore,
  RouteShopAdminMarketing,
  RouteShopAdminStatistics,
  RouteShopAdminShopSetting,
  RouteDealerInfomation,
  RouteDealerShop,
  RouteDealerTransaction,
  RouteDealerIndex,
  RouteDealerSetting,
  RouteYibao,
  RouteMerchantBase,
  RouteMerchantOrder,
  RouteMerchantSellers,
  RouteMerchantCompanydata,
  RouteMerchantSetting,
  RouteMerchantMarkteing,
  RouteMerchantGoods,
  RouteMerchantPoint,
  RouteMerchantTemplate,
  RouteMerchantYiBao,
  RouteShopAdminPointsMall,
  RouteShopAdminYiBao
}
